var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-primary",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.navigate.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }